<script>

    import { toast } from 'bulma-toast'
    import { orderLinkStore, popupStore } from '../stores'
    import { createEventDispatcher } from 'svelte'

    import QuotationsService from '../$services/quotations.service'
    import NumeralMethods from '../$methods/numeral.methods'

    import Spinner from '../$components/spinner.svelte'
    import Message from '../$components/message.svelte'

    const dispatch = createEventDispatcher()

    export let delivery
    export let quotation
    export let requestAccess

    const { BRAND } = _CONSTANTS_

    let quotations = []
    let loading = true

    let pickup = $orderLinkStore.pickup
    let ipackage = $orderLinkStore.package

    getQuotations()

    async function getQuotations() {

        const data = {
            pickup,
            delivery,
            package: ipackage
        }

        const queryData = {
            requestAccess
        }

        loading = true
        const resp = await QuotationsService.getQuotations(data, queryData)
        loading = false

        if(!resp.success)
            return toast({message: resp.error.message, type: 'is-danger'})

        quotations = resp.data
    }

    function onSelected(item) {
        quotation = item
        dispatch('selected', item)
    }
    
</script>

<Spinner {loading} />
<Message show={!loading && !quotations.length} message="Sin cobertura" />

{#if !loading && quotations.length}
    <div class="columns">
        <div class="column">
            <div class="title">Origen</div>
            <div class="title">{pickup.zipcode} {pickup.city || ''}</div>
        </div>
        <div class="column">
            <div class="title">Destino</div>
            <div class="title">{delivery.zipcode} {delivery.city || ''}</div>
        </div>
        <div class="column">
            <div class="title">Paquete</div>
            <div class="title">{ ipackage.width }cmx{ ipackage.height }cmx{ ipackage.length}cm</div>
        </div>
    </div>
    <hr>
    <div class="items-space space-bottom">
        <div class="icon-text">
            <span class="icon">
                <i class="fas fa-truck"></i>
            </span>
            <span>Proveedor</span>
        </div>
        <div class="icon-text">
            <span class="icon">
                <i class="fas fa-truck"></i>
            </span>
            <span>Servicio</span>
        </div>
        <div class="icon-text">
            <span class="icon">
                <i class="fas fa-dollar-sign"></i>
            </span>
            <span>Precio</span>
        </div>
        <div class="icon-text">
            <span class="icon">
                <i class="fas fa-calendar"></i>
            </span>
            <span>Entrega</span>
        </div>
        <div class="icon-text">
            <span class="icon">
                <i></i>
            </span>
            <span></span>
        </div>
        <div class="icon-text">
            <span class="icon">
                <i></i>
            </span>
            <span></span>
        </div>
    </div>
    {#each quotations as quotation}
        <div class="columns items-center">
            <div class="column">
                <img class="provider-image" src="images/{quotation.provider.replace(' Partner', '')}.svg" alt="{quotation.provider}">
            </div>
            <div class="column">
                <div>{ quotation.service }</div>
            </div>
            <div class="column">
                <div>{ NumeralMethods.cash(quotation.finalPrice) }</div>
            </div>
            <div class="column">
                <div>{ quotation.days } Días</div>
            </div>
            <div class="column">
                <div class="items-end">
                    <button on:click={() => onSelected(quotation)} class="button is-primary">
                        <span class="icon"><i class="fas fa-truck"></i></span>
                    </button>
                </div>
            </div>
        </div>
        <div class="columns">
            <div class="column">
                <div class="tags">
                    {#if quotation.insurancePrice}
                        <span class="tag is-danger">Precio ${quotation.shipmentPrice} + Seguro ${quotation.insurancePrice}</span>
                    {/if}
                    {#if !quotation.isDeliveryHome}
                        <span class="tag is-danger">Sin entrega a domicilio</span>
                    {/if}
                    {#if quotation.isCoverageCost}
                        <span class="tag is-danger">Zona extendida</span>
                    {/if}
                    {#if quotation.paymentType === 'prepaid'}
                        <span class="tag is-primary">Guía prepago { quotation.prepaidShipments }/{ quotation.prepaidShipmentsTotal }</span>
                    {/if}
                    {#if quotation.information}
                        <span class="tag is-primary icon-text" style="color: white;">
                            <span>{quotation.information}&nbsp;&nbsp;</span>
                            <span on:click={() => popupStore.set('frequency_popup')} class="class-icon"><i class="fas fa-question-circle" style="color: whitesmoke; cursor: pointer;"></i></span>
                        </span>
                    {/if}
                </div>
            </div>
        </div>
    {/each}
{/if}